import React from "react";
import AuthenticatedUserLayout from "../layouts/AuthenticatedUserLayout";
import {AuthorizedContextProvider} from "../context/AuthorizedContext";
import {Helmet} from "react-helmet";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import SingleShipmentTrackingComponents
    from "../components/page-single-shipment-tracking/SingleShipmentTrackingComponents";
import CloseBottomBar from "../components/core/CloseBottomBar";
import {SHIPMENT_TRACKING_PAGE_PATH} from "../layouts/navigation/Navigator";
import queryString from 'query-string';
import AddEventCommentButtonsToolbar from "../components/core/shipments/AddEventCommentButtonsToolbar";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {IShipment} from "../components/core/shipments/ShipmentList";
import { normalizeToString } from "../utils/QueryParamNormalizerUtils";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flex: 1,
            marginBottom: 80
        }

    })
);


export interface IShipmentSummary {
    reference?: string
    uuid: string
    shipper: string
    consignee: string
    status: string
    pieces: number
    weight: number
    volume: number
    deliveryTerm: string
    orderDate: string
    officePartyTypes: string[]
    departure: string
    arrival: string
    weightUnit: string
    volumeUnit: string
}

const SingleShipmentTrackingPage = () => {

    const {t} = useTranslation();
    const navigate = useNavigate();

    const classes = useStyles();
    const location = useLocation();
    const [shipment, setShipment] = React.useState<IShipment | undefined>(undefined);
    const {redirect} = queryString.parse(location.search);
    const {uuid} = useParams<{ uuid: string }>();

    const shipmentTitle = shipment ? ` - ${shipment.spotID} (${t("core.modality." + shipment.modality)})` : "";

    return (<AuthorizedContextProvider>

            <Helmet>
                <title>{t("page.title.shipment-tracking")}</title>
                <meta name="description" content={t("page.title.shipment-tracking")}/>
            </Helmet>

            <div className={classes.root}>
                <AuthenticatedUserLayout pageTitle={t("page.title.shipment-tracking") + shipmentTitle}>

                    {uuid && (<AddEventCommentButtonsToolbar uuid={uuid} shipmentId={shipment?.shipmentId}/>)}

                    <SingleShipmentTrackingComponents setShipment={setShipment}/>

                </AuthenticatedUserLayout>
            </div>

            <CloseBottomBar executeClose={() => navigate(normalizeToString(redirect) ?? SHIPMENT_TRACKING_PAGE_PATH)}/>

        </AuthorizedContextProvider>
    );


};

export default SingleShipmentTrackingPage;
